<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 col-md-7 mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Introduction</h4>
					</div>
					<div class="card-body">
						<p>
							Widenode is a data ecosystem platform.
							It allows various independent interconnected "data nodes" to act as a unified hierarchical data sharing and governance network.
							Widenode can be used as a data layer service and management dashboard for web and desktop applications.
							It also facilitates robust data distribution, collaboration, organization and delivery.
						</p>
						
						<h6>High Level Features</h6>
						<ul>
							<li>Support for multiple underlying data sources:
								<ul>
									<li>MongoDB</li>
									<li>Oracle DB</li>
									<li>Microsoft SQL Server</li>
								</ul>
							</li>
							<li>Ecosystem connectivity with socket tunneling for non-exposed PCs and servers.</li>
							<li>Multi-layer data security and authorizations.</li>
							<li>Collaboration and sharing of project elements across the ecosystem.</li>
							<li>3 levels of data (collection) referencing:
								<ul>
									<li>Within the same project,</li>
									<li>Between projects in the same node,</li>
									<li>Across nodes of a connected ecosystem.</li>
								</ul>
							</li>
							<li>Data augmentation.</li>
							<li>Built-in and integrated user accounts (SSO, LDAP/AD)</li>
						</ul>
						<h6>Upcoming Features</h6>
						<ul>
							<li>Powerful hierarchical schemas.</li>
							<li>Structured data mixins.</li>
							<li>Support for <a href="https://json-schema.org">JSON Schema</a></li>
							<li>Realtime data channels across the ecosystem.</li>
							<li>Authentication master nodes and cross-node account security.</li>
						</ul>
						<p>Here is a high level view of Widenode's architecture, including some key components:</p>
						<img src="static/img/widenode-structure.png" style="width: 100%;">
					</div>
				</div>
			</div>
			<div class="col-lg-4 col-md-5 mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Getting Started</h4>
					</div>
					<div class="card-body">
						<p>This interface belongs to its "home" node <strong>{{homeNode.$id}}</strong>, but can be used to access any other node in the connected ecosystem:</p>
						<ul class="list-unstyled">
							<li><router-link tag="button" class="btn btn-primary mb-4" v-if="homeNode" :to="'/nodes/'+homeNode.$id">Enter Current Node ({{homeNode.$id}})</router-link></li>
							<li><router-link tag="button" class="btn btn-primary" :to="'/nodes/'">Browse the Connected Ecosystem</router-link></li>
						</ul>
					</div>
				</div>
				<!--
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Tutorials</h4>
					</div>
					<div class="card-body">
						<ul class="list-unstyled">
							<li><a href="#t1">Installing Nodes</a></li>
							<li><a href="#t2">Connecting to the Ecosystem</a></li>
							<li><a href="#t3">Managing Projects</a></li>
							<li><a href="#t4">Working with Collections</a></li>
							<li><a href="#t5">Data Authorization</a></li>
						</ul>
					</div>
				</div>
				
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Developer Resources</h4>
					</div>
					<div class="card-body">
						<ul class="list-unstyled">
							<li><a href="#r1">API Reference</a></li>
							<li><a href="#r2">Technical Documentation</a></li>
							<li><a href="#r3">Accessing Data</a></li>
							<li><a href="#r4">Custom Applications</a></li>
							<li><a href="#r5">Advanced Data Governance</a></li>
						</ul>
					</div>
				</div>
				-->
			</div>
		</div>
		<!-- <div class="row">
			<div class="col mb-4">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Frequently Asked Questions</h4>
					</div>
					<div class="card-body">
						[FAQ CONTENT]
					</div>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
	name: "welcome-view",
	computed:
	{
		...mapGetters( "nodes", {
			getNode: "node", // map STATE projects/all to "projects" AS A FUNCTION, which requires the nodeId as input!
			homeNode: "homeNode",
			parentNode: "parent",	// FUNCTION
		}),
	}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Welcome.vue